// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2r8ys","buttons":"SendReceipts_buttons__3bJCR","email":"SendReceipts_email__2-VSl","bookApptTitle":"SendReceipts_bookApptTitle__1cuXR"};